import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-typography-1',
  templateUrl: './1.component.html',
  styleUrls: ['./1.component.scss'],
})
export class VbTypography1Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
